export const banner = (baseUrl: string): string => `${baseUrl}/ads/v1/banner`;
export const bannerClick = (baseUrl: string, bannerId): string => `${baseUrl}/ads/v1/banner/${bannerId}/click`;
export const bannerForm = (baseUrl: string, bannerId): string => `${baseUrl}/ads/v1/banner/${bannerId}/form`;
